// this is the enum for the data source configs
const DataSourceConfigsEnums = {
  DOMAIN_TYPE: 'domain_type',
  IDENTIFIER: 'identifier',
  ENDPOINT: 'endpoint',
  VOCABULARY_ID: 'vocabulary_id',
  API_INTEGRATION_ID: 'api_integration_id',
  ADDITIONAL_FILE_EXTENSIONS: 'additional_file_extensions',
};

// the only extensions a PDF_IMPORT data source may opt in to alongside .pdf, mirrored
// from app/lib/enums/data_source/data_source_enums.py PdfImportAdditionalFileExtension
const PDF_IMPORT_ADDITIONAL_FILE_EXTENSIONS = {
  JPG: 'jpg',
  JPEG: 'jpeg',
  PNG: 'png',
};

const PDF_IMPORT_ADDITIONAL_FILE_EXTENSIONS_OPTIONS = [
  { value: PDF_IMPORT_ADDITIONAL_FILE_EXTENSIONS.JPG, label: 'jpg' },
  { value: PDF_IMPORT_ADDITIONAL_FILE_EXTENSIONS.JPEG, label: 'jpeg' },
  { value: PDF_IMPORT_ADDITIONAL_FILE_EXTENSIONS.PNG, label: 'png' },
];

// this is the domain type that will be used to search the Syndigo API
const DATA_SOURCE_DOMAIN_TYPE = {
  MARKET_PLACE: 'market_place',
  FOOD_SERVICE: 'food_service',
};

const DATA_SOURCE_DOMAIN_TYPE_OPTIONS = [
  { value: DATA_SOURCE_DOMAIN_TYPE.MARKET_PLACE, label: 'Market Place' },
  { value: DATA_SOURCE_DOMAIN_TYPE.FOOD_SERVICE, label: 'Food Service' },
];

// this is the identifier that will be used to search the Syndigo API
const DATA_SOURCE_IDENTIFIER = {
  GTIN: 'GTIN',
  UPC: 'UPC',
};

const DATA_SOURCE_IDENTIFIER_OPTIONS = [
  { value: DATA_SOURCE_IDENTIFIER.GTIN, label: 'GTIN' },
  { value: DATA_SOURCE_IDENTIFIER.UPC, label: 'UPC' },
];

// this is the endpoint that will be used to search the Syndigo API
const DATA_SOURCE_ENDPOINT = {
  PRODUCT_SEARCH_BY_ATTRIBUTE_FILTER: 'product_search_by_attribute_filter',
  PRODUCT_SEARCH_BY_IDENTIFIER: 'product_search_by_identifier',
  PRODUCT_SEARCH_BY_GTIN: 'product_search_by_gtin',
  PRODUCT_SEARCH_DELTA: 'product_search_delta',
};

const DATA_SOURCE_ENDPOINT_OPTIONS = [
  {
    value: DATA_SOURCE_ENDPOINT.PRODUCT_SEARCH_BY_ATTRIBUTE_FILTER,
    label: 'Product Search By Attribute Filter',
  },
  {
    value: DATA_SOURCE_ENDPOINT.PRODUCT_SEARCH_BY_IDENTIFIER,
    label: 'Product Search By Identifier',
  },
  { value: DATA_SOURCE_ENDPOINT.PRODUCT_SEARCH_BY_GTIN, label: 'Product Search By GTIN' },
  { value: DATA_SOURCE_ENDPOINT.PRODUCT_SEARCH_DELTA, label: 'Product Search Delta' },
];

export {
  DATA_SOURCE_DOMAIN_TYPE,
  DATA_SOURCE_DOMAIN_TYPE_OPTIONS,
  DataSourceConfigsEnums,
  DATA_SOURCE_IDENTIFIER,
  DATA_SOURCE_IDENTIFIER_OPTIONS,
  DATA_SOURCE_ENDPOINT,
  DATA_SOURCE_ENDPOINT_OPTIONS,
  PDF_IMPORT_ADDITIONAL_FILE_EXTENSIONS,
  PDF_IMPORT_ADDITIONAL_FILE_EXTENSIONS_OPTIONS,
};
